import { asHintId, type Hint } from '@/shared/stores';

import { DASHBOARD_PATIENT_LOCATION_ANCHOR } from '../anchors';

export const dashboardPatientLocationHint: Hint = {
  id: asHintId('dashboard:patient-location'),
  version: 1,
  priority: 45,
  anchor: DASHBOARD_PATIENT_LOCATION_ANCHOR,
  copy: {
    title: 'Patient location matters',
    body: 'The state shown here is what determines licensing eligibility. If a patient travels mid-encounter, their state can change — keep it in mind before prescribing or ordering labs.',
    primaryLabel: 'Got it',
    secondaryLabel: 'Skip',
  },
};
